import { render, staticRenderFns } from "./EquipmentDetails.vue?vue&type=template&id=1016072a"
import script from "./EquipmentDetails.vue?vue&type=script&lang=js"
export * from "./EquipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./EquipmentDetails.vue?vue&type=style&index=0&id=1016072a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports